import transformProps from '@didi/webx-ui-utils/src/transform-props'
import config from '../../../views/hy/config'

const props = {
  info: {
    type: Object,
    value: () => config,
  },
  pageConfig: {
    type: Object,
    value: () => ({
      index: {
        style: {
          backgroundColor: '#00b081',
        },
        button: {
          text: '立即领取',
          gotoText: '去使用',
        },
        link: 'https://didi.cn/K0kQq63',
        title: '货运券免费领',
      },
      rule: {
        link: '',
        style: {
          top: 40,
          color: '#FFFFFF',
          backgroundColor: 'rgba(0,0,0,.3)',
        },
      },
      redPacket: {
        _closeTitle: '货运福利券包',
      },
      popup: {
        button: {
          text: '去使用',
        },
      },
      header: {},
      imageList: [
        {
          image:
            'https://ut-static.udache.com/webx/ut/1ED59d8F1RjRBb0y1QGTH.png',
          style: {
            marginTop: 40,
            width: 700,
          },
        },
      ],
    }),
  },
}

const mockIndex = {
  errno: 0,
  errmsg: '',
  traceid: '123',
  data: {
    group: {
      id: '1e32e345456454',
      status: 1,
    },
    rewards: [
      {
        type: 'coupon',
        coupon: {
          usage_limit: '满￥200可用',
          valid_period: '有效期截止2021.12.24',
          name: '加油福利券',
          type: 1,
          max_benefit_capacity: {
            value: 30,
            unit: '元',
          },
        },
      },
    ],
    activity_info: {
      id: 1,
      rewards: [
        {
          type: 'coupon',
          coupon: {
            name: '加油福利券',
            usage_limit: '',
            valid_period: '',
            type: 1,
            max_benefit_capacity: {
              value: 20,
              unit: '元',
            },
          },
        },
      ],
    },
  },
}

const { propsForView, propsForModel, propsForStory } = transformProps(props)

export { props, propsForView, propsForModel, propsForStory, mockIndex }
